module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_8023.993ca6d3.png";